export { default as appStoreIcon } from "./appStore.png";
export { default as chatIcon } from "./chat.png";
export { default as groupIcon } from "./group.png";
export { default as playStoreIcon } from "./playstore.png";
export { default as videoPlaceholder } from "./video-placeholder.png";
export { default as appIcon } from "./snaphabit-jj.png";
